import { ScaleLinear } from 'd3-scale';

import { RunLabware } from '../../types';

type DomainObject = { min: number; max: number };

export const getDomainXObject = (labwareData: RunLabware): DomainObject =>
  Object.values(labwareData).reduce(
    (acc, { tasks }) => {
      tasks.forEach(({ duration }) => {
        if (duration.start < acc.min) acc.min = duration.start;
        if (duration.end > acc.max) acc.max = duration.end;
      });
      return acc;
    },
    { min: Infinity, max: 0 }
  );

export const getPaddedScale = (
  scale: ScaleLinear<number, number, never>,
  padding: number
) => {
  const [rangeMin = 1, rangeMax = 1] = scale.range();
  return scale.copy().range([rangeMin + padding, rangeMax - padding]);
};
